module.exports = {
  addressCountry: 'United States',
  addressLocality: 'Austin',
  addressRegion: 'Texas',
  author: 'Everlywell', // Author for RSS author segment and SEO schema
  authorUrl: 'https://www.everlywell.com/', // URL used for author and publisher schema, can be a social profile or other personal site
  backgroundColor: '#e9e9e9', // Used for Offline Manifest
  contactType: 'customer support',
  copyright: `Copyright © ${new Date().getFullYear()} EverlyWell, Inc.`, // Copyright string for the RSS feed
  email: 'contact@everlywell.com',
  facebook: 'https://www.facebook.com/everlywell/',
  founder: 'Julia Cheek',
  foundingDate: '2015',
  keywords:
    'home health testing, online blood test, online health test, at home blood test, at home lab test, blood test, urine test, saliva test, food intolerance test, food sensitivity test, fertility test, hormone testing, self testing',
  legalName: 'Everly Well, Inc.',
  linkedin: 'https://www.linkedin.com/company/everlywell',
  pinterest: 'https://www.pinterest.com/everlywell/',
  postalCode: '78701',
  postsPerHomePage: 10, // Number of posts shown on the 1st page of the index.js template (home page)
  postsPerPage: 10, // Number of posts shown on paginated pages
  publisher: 'Everlywell', // Organization name used for SEO schema
  shortTitle: 'Everlywell', // Used for App manifest e.g. Mobile Home Screen
  siteDescription:
    'Home health testing has never been easier. Order at-home tests directly to your door and get your results online within days.',
  siteLogo: '/logo/ew-mark-1024.png', // Logo used for SEO, RSS, and App manifest
  siteTitle: 'Home Health Testing | Results You Can Understand | Everlywell',
  siteTitleAlt: 'Everlywell: Home Health Testing Made Easy', // This allows an alternative site title for SEO schema.
  siteUrl: 'https://www.everlywell.com', // Site domain. Do not include a trailing slash! If you wish to use a path prefix you can read more about that here: https://www.gatsbyjs.org/docs/path-prefix/
  streetAddress: '823 Congress, Suite 1200',
  themeColor: '#121212', // Used for Offline Manifest
  title: 'Everlywell - Innovative at-home Health Testing',
  twitter: 'https://twitter.com/everly_well',
  userTwitter: '@everly_well', // Change for Twitter Cards
  sitemaps: [
    // List of sitemap URLs. The sitemap generation happens in the onPostBuild.ts file.
    'https://www.everlywell.com/sitemap-index.xml',
    'https://www.everlywell.com/blog/sitemap-index.xml',
    'https://support.everlywell.com/sitemap.xml',
  ],
  robotsDisallowedPaths: [
    // Don't let Google crawl these paths in robots.txt
    '/hi',
    '/orders',
    '/ancestry/',
    '/confirmation/',
    '/cart',
    '/checkout',
    '/partner-activation',
    '/practitioner-activation',
    '/privacy-policy/',
    '/products/prostate-specific-antigen/', // TODO: Please remove this line when this product is released.
    '/terms-and-conditions/',
    '/thank-you',
    '/download-app',
    '/weight-loss-online',
    '/glp-1-weight-loss-online-v2',
    '/members/consentandnotice',
  ],
};
